import React, { Component } from 'react';
import { Table, Tag, Spin } from 'antd';
import {
  QuestionCircleOutlined,
  ExclamationCircleOutlined,
  CheckCircleOutlined,
  LoadingOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  CodeOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import './Output.scss';
import 'font-awesome/css/font-awesome.min.css';
import StatusBox from '../UI/StatusBox/StatusBox';
import { LogoStatus } from '../../const';
const { NotAttempted, Accepted, Unknown, TimeLimit, WrongAnswer, CompilerError, RuntimeError } =
  LogoStatus;

const LogoStyleMap = {
  [NotAttempted]: 'gray', //nologo yet
  [Unknown]: 'gray', //unattempted
  [Accepted]: ' green', // correct
  LOAD: 'gray', //do not have the results yet, call sent to server
  [TimeLimit]: 'orange', // failed, time limit exceeded
  [WrongAnswer]: 'red', // failed, output did not match input
  [CompilerError]: 'orange', //compiler
  [RuntimeError]: 'red', // runtime error
};

const LogoVerdictMap = {
  [NotAttempted]: '', //nologo yet
  [Unknown]: ' Not Attempted', //unattempted
  [Accepted]: ' Success', // correct
  LOAD: '', //do not have the results yet, call sent to server
  [TimeLimit]: ' Time Limit Exceeded', // failed, time limit exceeded
  [WrongAnswer]: ' Failed', // failed, output did not match input
  [CompilerError]: ' Compilation Failed', //compiler
  [RuntimeError]: ' Runtime Error', // runtime error
};

const LogoAntdMap = {
  [NotAttempted]: <QuestionCircleOutlined />, // no logo yet
  [Unknown]: <ExclamationCircleOutlined />, // unattempted
  [Accepted]: <CheckCircleOutlined />, // correct
  LOAD: <LoadingOutlined spin />, // loading
  [TimeLimit]: <ClockCircleOutlined />, // time limit exceeded
  [WrongAnswer]: <CloseCircleOutlined />, // wrong answer
  [CompilerError]: <CodeOutlined />, // compiler error
  [RuntimeError]: <WarningOutlined />, // runtime error
};

const difficultyColorMap = {
  EZ: '#4E957F',
  MD: '#ffb933',
  HD: '#D63321',
};

const difficultyTextMap = {
  EZ: 'Easy',
  MD: 'Medium',
  HD: 'Hard',
};

class OutPut extends Component {
  render() {
    let index = -1;
    const data = this.props.testcases.map(function (data) {
      index++;
      return { index, key: index, ...data };
    });

    const columns = [
      {
        title: 'Sample Case',
        dataIndex: 'index',
        key: 'index',
      },
      {
        title: 'Difficulty Level',
        dataIndex: 'difficulty',
        key: 'difficulty',
        render: data => (
          <React.Fragment>
            <Tag
              style={{
                color: difficultyColorMap[data],
                backgroundColor: 'transparent',
                borderBlockColor: difficultyColorMap[data],
                border: '1px solid',
              }}
              color={difficultyColorMap[data]}
            >
              {difficultyTextMap[data]}
            </Tag>
          </React.Fragment>
        ),
      },
      {
        title: 'Points',
        dataIndex: 'points',
        key: 'points',
      },
      {
        title: 'Status',
        dataIndex: 'logo',
        key: 'status',
        render: logo => (
          <React.Fragment>
            <span style={{ color: LogoStyleMap[logo] }}>{LogoAntdMap[logo]}</span>
            {LogoVerdictMap[logo]}
          </React.Fragment>
        ),
      },
    ];

    let passCases = this.props.testcases.filter(tc => tc.logo === Accepted).length;
    let totalCases = this.props.testcases.length;
    let leftCases = totalCases - passCases;
    let testcaseError = this.props.testcases.find(tc => {
      return tc.compiler_error || tc.runtime_error;
    });
    let message =
      leftCases +
      ' out of ' +
      totalCases +
      ' testcases do not pass. ' +
      'You can use the Custom Input tab, to test your code against custom input.';
    if (this.props.probStatus === 'ALL_PASS') {
      if (this.props.leftCount > 0) {
        message =
          'Congratulations, all test cases pass for this problem. You still have ' +
          this.props.leftCount +
          ' problems left which need work.';
      } else {
        message =
          'Congratulations, all test cases pass for this problem. You have completed all problems. ' +
          'hit the submit test button on top right to complete and submit the test.';
      }
    } else if (this.props.probStatus === NotAttempted) {
      message =
        'Write code in the editor on right and then hit Submit Code button to evaluate the test cases.' +
        'You can also use the Custom Input tab, to test your code against custom input.';
    }

    // Show loading spinner when results are being fetched
    if (this.props.isLoading) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '200px',
            flexDirection: 'column',
          }}
        >
          <Spin size="large" />
          <p style={{ marginTop: '16px', color: '#666' }}>Running tests... Please wait.</p>
        </div>
      );
    }

    // Check if all test cases passed
    const allTestsPassed = passCases === totalCases && totalCases > 0;

    return (
      <div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '16px',
            fontSize: '14px',
            color: '#000',
          }}
        >
          {!allTestsPassed ? (
            <p style={{ paddingTop: '15px' }}>
              <em>{message}</em>
            </p>
          ) : (
            <>
              <span>All test cases passed</span>
              <CheckCircleOutlined style={{ color: '#52c41a', fontSize: '16px' }} />
            </>
          )}
        </div>

        <h2
          style={{
            fontWeight: 'bold',
            textAlign: 'left',
            paddingLeft: '20px',
            marginBottom: '20px',
          }}
        >
          Output{' '}
        </h2>
        {testcaseError && (
          <React.Fragment>
            <StatusBox
              title={
                'Status: ' + (testcaseError.compiler_error ? 'Compilation Failed' : 'Runtime Error')
              }
              value={testcaseError.stderr}
              readOnly={true}
              error={true}
            />
          </React.Fragment>
        )}
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          rowClassName={() => ''}
        />
      </div>
    );
  }
}

export default OutPut;
